// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"AuthProviderLoginButtons_buttonWrapper__WNcFo"};